import * as types from 'modules/followUp/actionTypes';
import { FETCH_INTERVENTION_SUCCESS, UPDATE_INTERVENTION_SUCCESS } from 'modules/interventions/actionTypes';
import { CHANGE_INTERVENTION_STEP_SUCCESS } from 'modules/steps/actionTypes';
import { createDictionary } from 'utils/ObjectUtils';
import { createEntityAdapter, createReducer } from 'utils/ReduxUtils';

/** @typedef {import('utils/ReduxUtils').EntitySlice<import("../types").FollowUp>} FollowUpDataEntity */

/** @type {import('utils/ReduxUtils').EntityAdapter<import('../types').FollowUp>} */
const followUpAdapter = createEntityAdapter({ selectId: ({ id }) => id });

const FOLLOW_UP_FORMATTER = createDictionary(
  {
    page: ({ intervention, partsIntervention, ...followUp }) => ({
      ...followUp,
      interventionId: intervention?.id,
      partsInterventionId: partsIntervention?.id,
    }),
  },
  followUp => followUp
);

const formatter = followUp => FOLLOW_UP_FORMATTER[followUp.projectionType](followUp);

/**
 * @param {FollowUpDataEntity} state
 * @param {import('modules/global/generic.types').PageContent<import('../types/projections/page-follow-up').PageFollowUp>} action
 * @returns {FollowUpDataEntity}
 */
const addManyFromPage = (state, { payload: { content } }) => followUpAdapter.updateMany(state, content.map(formatter));

const unscheduleFollowUp = (state, { payload: followUp }) =>
  followUpAdapter.updateOne(state, { ...followUp, sendDate: null });

const updateFormIntervention = (state, { payload: { followUp } }) =>
  (followUp ? followUpAdapter.updateOne(state, followUp) : state);

export default createReducer(followUpAdapter.getInitialState(), {
  [types.FETCH_FOLLOW_UPS_SUCCESS]: addManyFromPage,
  [types.SEND_FOLLOW_UP_SUCCESS]: followUpAdapter.updateOne,
  [types.UNSCHEDULE_FOLLOW_UP_SUCCESS]: unscheduleFollowUp,
  [types.SCHEDULE_FOLLOW_UP_SUCCESS]: followUpAdapter.updateOne,
  [FETCH_INTERVENTION_SUCCESS]: updateFormIntervention,
  [UPDATE_INTERVENTION_SUCCESS]: updateFormIntervention,
  [CHANGE_INTERVENTION_STEP_SUCCESS]: updateFormIntervention,
});
